import { useTheme } from '@material-ui/core';
import { getSvgPath, mediaUrls } from 'globalconfig/constants/mediaUrls';
import PropTypes from 'prop-types';
import React from 'react';
import { ReactSVG } from 'react-svg';
import Wrapper from './style';

const layout = window?.$environment?.CURRENT_LAYOUT;
const SvgIcon = ({
  value,
  onClick,
  showTenantBasedColor = false,
  isSelected = false,
  className = '',
  wrpClass = '',
  primary = false,
  id = '',
  fullWidth = false,
}) => {
  const theme = useTheme();
  const color = isSelected ? theme.palette?.secondary?.main : theme.colors?.SECONDARY_GRAY || theme.palette?.leftMenuText?.color;

  const updateColor = (svg) => {
    if (showTenantBasedColor && svg) {
      svg.style.color = color;
      const elements = svg.querySelectorAll('path, circle, rect, g');
      elements.forEach((element) => {
        const computed = window.getComputedStyle(element);
        const fill = computed.fill;
        const stroke = computed.stroke;

        if (fill && fill !== 'none' && !element.style.fill) {
          element.style.fill = color;
        }

        if (stroke && stroke !== 'none' && !element.style.stroke) {
          element.style.stroke = color;
        }
      });
    }
  };

  if (!value) return null;

  if ((value === mediaUrls.pageBackButton && layout === 'SpireonNew') || value !== mediaUrls.pageBackButton) {
    if (showTenantBasedColor) {
      return (
        <Wrapper.SVG_Wrapper isSelected={isSelected} fullWidth={fullWidth} className={wrpClass}>
          <ReactSVG
            src={getSvgPath(value)}
            beforeInjection={(svg) => {
              updateColor(svg);
              svg.setAttribute('id', id);
            }}
            className={className}
            onClick={onClick}
            style={{
              alignItems: 'center',
            }}
          />
        </Wrapper.SVG_Wrapper>
      );
    }
    return (
      <Wrapper.SvgWrapper fullWidth={fullWidth} className={wrpClass}>
        <ReactSVG
          className={className}
          src={getSvgPath(value)}
          beforeInjection={(svg) => {
            svg.setAttribute('id', id);
          }}
          onClick={onClick}
          style={{
            ...{
              alignItems: 'center',
            },
            ...(primary
              ? {
                color: `${theme.colors.PRIMARY_CONTRAST}`,
              }
              : {}),
          }}
        />
      </Wrapper.SvgWrapper>
    );
  }

  return <></>;
};

SvgIcon.propTypes = {
  value: PropTypes.string.isRequired,
};

export default SvgIcon;
